module.exports = __webpack_public_path__ + "static/img/slmBanner.8dea8be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slmBanner.png
// module id = LzCH
// module chunks = 2